import { render } from "./WCDigitalCouponRibbon.vue?vue&type=template&id=774706a0&scoped=true&ts=true"
import script from "./WCDigitalCouponRibbon.vue?vue&type=script&lang=ts"
export * from "./WCDigitalCouponRibbon.vue?vue&type=script&lang=ts"

import "./WCDigitalCouponRibbon.vue?vue&type=style&index=0&id=774706a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774706a0"]])

export default __exports__